import { useState } from 'react';
import { Avatar, Dropdown, MenuProps, Space } from 'antd';
import {
  ArrowDownIcon,
  ChartIcon,
  ClipboardCloseIcon,
  DropDownArchiveIcon,
  LogOutIcon,
  PaypalIcon,
  ProfileIcon,
  TeacherIcon
} from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import { globalConst, onTrackYandexGoal } from 'modules/global';

import { LogOutModal } from 'components';

const ProfileDropDown = ({ userName, userImage }: { userName: string; userImage: string }) => {
  const t = useTranslations();
  const [openLogOut, setOpenLogOut] = useState(false);
  const hasPremium = useAppSelector(state => state.user.premium);

  const items: MenuProps['items'] = [
    {
      key: 'profil',
      label: (
        <Link href={globalConst.pageNames.CABINET}>
          <Space>
            <ProfileIcon />
            {t('profile.title')}
          </Space>
        </Link>
      )
    },
    !hasPremium
      ? {
          key: 'payment',
          label: (
            <Link
              onClick={() => onTrackYandexGoal(globalConst.yandexGoalKeys.profile_dropdown_pro)}
              href={globalConst.pageNames.PRO}
            >
              <Space>
                {/* eslint-disable-next-line i18next/no-literal-string */}
                <PaypalIcon />
                Akam
                <div className="rounded-[6px] border border-gray-200 px-2 shadow-md">
                  <p className="bg-gradient-to-br from-[#FFE500] to-[#F25500] bg-clip-text font-bold text-transparent">
                    PRO
                  </p>
                </div>
              </Space>
            </Link>
          )
        }
      : null,
    {
      key: 'archive',
      label: (
        <Link href={globalConst.pageNames.SAVED_TEST}>
          <Space>
            <DropDownArchiveIcon />
            {t('saqlanganlar.title')}
          </Space>
        </Link>
      )
    },
    {
      key: 'clipboard',
      label: (
        <Link href={globalConst.pageNames.UNFINISHED}>
          <Space>
            <ClipboardCloseIcon />
            {t('yakunlanmaganlar.title')}
          </Space>
        </Link>
      )
    },
    // keyinchalik qo'shilishi mumkin ekan!
    // {
    //   key: 'feedbacks',
    //   label: (
    //     <Link href="https://t.me/AkamHelpBot?start=web-desktop" target="_blank">
    //       <Space>
    //         <MessageQuestionHeaderIcon />
    //         {t('qollab_quvvatlash')}
    //       </Space>
    //     </Link>
    //   )
    // },
    {
      key: 'results',
      label: (
        <Link href={globalConst.pageNames.RESULTS}>
          <Space>
            <ChartIcon />
            {t('mening_natijalarim')}
          </Space>
        </Link>
      )
    },
    {
      key: 'teacher',
      disabled: true,
      label: (
        <Link href="https://teacher.akam.uz/" target="_blank">
          <Space>
            <TeacherIcon />
            {t('oqituvchi_sahifasi')}
          </Space>
        </Link>
      )
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      onClick: () => setOpenLogOut(true),
      label: (
        <Space>
          <LogOutIcon />
          {t('chiqish')}
        </Space>
      )
    }
  ];

  return (
    <>
      <Dropdown
        dropdownRender={menu => <div className="w-50 mt-4">{menu}</div>}
        placement="bottomRight"
        menu={{ items }}
        trigger={['click']}
        className="cursor-pointer"
      >
        <Space>
          <Avatar
            className="!bg-gradient-to-br !from-[#6CD97E] !to-[#12B312]"
            src={userImage}
            alt="user profile"
            size={38}
          >
            {userName}
          </Avatar>
          <div className="hidden md:block">
            <ArrowDownIcon />
          </div>
        </Space>
      </Dropdown>

      <LogOutModal open={openLogOut} onClose={() => setOpenLogOut(false)} />
    </>
  );
};

export default ProfileDropDown;
